export const init = () => {
    const observer = new MutationObserver(() => {
        if (document.querySelector('.g-rating')) {
            const containers = document.querySelectorAll('.g-rating:not(.g-rating--clickable)');
            containers.forEach((item) => {
                let totalRating = Number(item.dataset.ratingPercent) * 5;
                const stars = item.querySelectorAll('.g-rating__star');
                stars.forEach((star) => {
                    if (totalRating > 100) {
                        star.style.setProperty('--star-width','100%');
                        totalRating -= 100;
                    } else {
                        star.style.setProperty('--star-width',`${totalRating}%`);
                        totalRating -= totalRating;
                    }
                })
            })
        }
    })
    observer.observe(document.body,{
        childList: true,
        subtree: true,
        attributes: false
    })    
    const observer2 = new MutationObserver(() => {
        if (document.querySelector('.g-rating--clickable')) {
            const clickableContainers = document.querySelectorAll('.g-rating--clickable');
            clickableContainers.forEach((item) => {
                const stars = item.querySelectorAll('.g-rating__star');
                let evaluation = item.querySelector('.g-rating__evaluation');
                let selectedRating = 0;
                stars.forEach((star, starIndex) => {
                    const starEvaluation = star.dataset.evaluation;
                    star.addEventListener('mouseover', () => {
                        evaluation.innerHTML = starEvaluation;
                    })
                    star.addEventListener('mouseout', () => {
                        evaluation.innerHTML = evaluation.dataset.evaluation;
                    })
                    star.addEventListener('mouseenter', () => {
                        star.classList.add('active');
                        stars.forEach((item, index) => {
                            item.style.removeProperty('--star-width');
                            if (index <= starIndex) {
                                item.classList.add('active');
                            }
                            if (item.classList.contains('active')) {
                                selectedRating += 20;
                            }
                        })
                    })
                    star.addEventListener('mouseleave', () => {
                        let totalRating =  item.dataset.ratingPercent * 5; 
                        stars.forEach((item) => {
                            item.classList.remove('active');
                            selectedRating = 0;
                            if (totalRating > 100) {
                                item.style.setProperty('--star-width','100%');
                                totalRating -= 100;
                            } else {
                                item.style.setProperty('--star-width',`${totalRating}%`);
                                totalRating -= totalRating;
                            }
                        })
                    })
                    star.addEventListener('click', () => {
                        item.dataset.ratingPercent = selectedRating;
                        evaluation.dataset.evaluation = starEvaluation;
                        let totalRating = item.dataset.ratingPercent * 5;
                        const dataArray = star.dataset.value.split('|');
                        document.querySelector('#rating-selected-value').value = dataArray[0];
                        document.querySelector('#rating-selected-value-hash').value = dataArray[1];
                        stars.forEach((item) => {
                            if (totalRating > 100) {
                                item.style.setProperty('--star-width','100%');
                                totalRating -= 100;
                            } else {
                                item.style.setProperty('--star-width',`${totalRating}%`);
                                totalRating -= totalRating;
                            }
                        })
                    })
                })
            })
        }
    })
    observer2.observe(document.body,{
        childList: true,
        subtree: false,
        attributes: false
    })
}